module.exports = "/_next/static/images/narwal-442fb7e6fd977cd26f0b86a1ce5caeed.png";